import onlineReputation from "../assets/images/BildUp/online-reputation.jpeg"
import paidAdsCategory from "../assets/images/BildUp/paid-ad-category.jpeg"
import UgcInfluencer from "../assets/images/BildUp/UGC-Influencer.PNG"
import personalBranding from "../assets/images/BildUp/personal-branding-management.JPG"
export const services = [
  {
    title: "SOCIAL MEDIA MARKETING",
    image:
      "https://images.pexels.com/photos/607812/pexels-photo-607812.jpeg?cs=srgb&dl=pexels-tracy-le-blanc-67789-607812.jpg&fm=jpg",
    description: `Our social media marketing services help businesses grow their online presence and engage with their target audience effectively. At BildUp we specialize in social media strategy, content creation, and campaign management across platforms like Facebook, Instagram, LinkedIn, and TikTok. By leveraging analytics, trends, and performance tracking, we ensure your brand stays visible and competitive online.`,
    keywords: "social media marketing services, Instagram marketing, TikTok growth, social media management"
  },
  {
    title: "CONTENT CREATION",
    image:onlineReputation,
    description:
      "We create high-quality, engaging, and brand-focused content that resonates with your audience. Your content is your brand’s voice. From scroll-stopping videos and graphic visuals to blog posts and photography that captures attention and drives engagement, our content creation services are tailored to boost brand visibility, encourage engagement, and build long-lasting brand loyalty. At BildUp we deliver creative content that connects and converts.",
    keywords: "content creation for brands, branded storytelling, short-form video, creative content agency."
  },
  
  {
    title: "PAID ADS & PERFORMANCE MARKETING",
    image: paidAdsCategory,
    description:
      "Maximize your ROI with precision-targeted advertising. We design and manage high-impact paid advertising campaigns that deliver measurable results. From Google Ads to social media advertising, our performance marketing approach ensures your ad spend works smarter focusing on driving conversions, increasing ROI, and helping your business reach its growth goals.",
    keywords: "paid ads services, performance marketing agency, Google Ads management, Facebook advertising"
  },
  {
    title: "DATA ANALYTICS & AUDIENCE INSIGHTS",
    image:
      "https://images.pexels.com/photos/97080/pexels-photo-97080.jpeg?cs=srgb&dl=pexels-negativespace-97080.jpg&fm=jpg",
    description:
      "Data drives smarter decisions. With BildUp's analytics and audience insights, you'll understand customer behavior and market trends, track performance, and identify opportunities for growth. We turn numbers into strategies, giving your business the competitive edge it needs.",
    keywords: "marketing analytics services, audience insights, data-driven marketing strategy"
  },
  
  {
    title: "PERSONAL BRANDING & MANAGEMENT",
    image: personalBranding,
    description: "Stand out as a leader in your industry. BildUp crafts personal branding strategies for executives, entrepreneurs, influencers, and thought leaders who want to grow their online presence. Our services include profile optimization, content strategy, and storytelling to help you stand out, grow influence, and attract the right opportunities.",
    keywords: "personal branding services, executive branding, LinkedIn branding, influencer personal brand management"
  },
  {
    title: "BRAND DEVELOPMENT & STRATEGY",
    image:
      "https://plus.unsplash.com/premium_photo-1707155465527-c5a2935b21cc?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDh8fGJsYWNrJTIwQlJBTkQlMjBERVZFTE9QTUVOVCUyMCUyNiUyMFNUUkFURUdZfGVufDB8fDB8fHww",
    description:
      "Strong brands don’t happen by chance-they’re built. Our brand development and strategy services help businesses establish a clear identity and strong positioning. From logo design and messaging to long-term brand growth strategies, we craft solutions that set helps startups and established companies stand apart in a crowded marketplace",
    keywords: "brand development services, brand strategy agency, build a brand identity"
  },
  {
    title: "MARKETING & CONTENT STRATEGY",
    image:
      "https://images.pexels.com/photos/7710055/pexels-photo-7710055.jpeg?cs=srgb&dl=pexels-a-darmel-7710055.jpg&fm=jpg",
    description:
      "Smart strategy drives successful campaigns. We design tailored marketing and content strategies that align with your business goals. From content planning to full- funnel marketing, we integrate audience research, storytelling, and distribution planning, to ensure that your brand speaks the right message to the right audience at the right time thereby increasing engagement and drive growth.",
    keywords: "marketing strategy agency, content strategy services, content planning"
  },
  {
    title: "UGC & INFLUENCER MARKETING MANAGEMENT",
    image: UgcInfluencer,
    description: "Authenticity wins! BildUp connects brands with influencers and creators to deliver authentic user-generated content (UGC) that resonates and builds trust and credibility. Our influencer marketing management services help you reach wider audiences and strengthen brand loyalty.",
    keywords: "influencer marketing agency, UGC for brands, influencer campaign management"
      
  },
  {
    title: "SEARCH ENGINE OPTIMIZATION (SEO)",
    image:
      "https://images.pexels.com/photos/67112/pexels-photo-67112.jpeg?cs=srgb&dl=pexels-caio-67112.jpg&fm=jpg",
    description:
      "Get found online with BildUp’s SEO services .Our SEO services ensure your business ranks higher on search engines. We focus on on-page optimization, keyword research, technical SEO, and content improvements to increase website traffic and make your brand more discoverable online.",
    keywords: "SEO services, search engine optimization agency, local SEO optimization, SEO content writing"
  },

  {
    title: "BRAND NARRATIVE & STORYTELLING",
    image:
      "https://images.pexels.com/photos/1181311/pexels-photo-1181311.jpeg?cs=srgb&dl=pexels-divinetechygirl-1181311.jpg&fm=jpg",
    description:
      "At BildUp, we believe that every brand has a story worth telling. We help businesses craft powerful brand stories that resonate with audiences. By weaving authenticity and creativity into your narratives, we strengthen brand identity, build emotional connections, and inspire loyalty",
    keywords: "brand storytelling agency, brand narrative development, storytelling in marketing"
  },
];